import { Text } from "@salestrak/ui";
import { FeatureFlagKey, useFeatureFlags } from "#app/hooks/use-feature-flags";
import { useFormFillDialogActions } from "#app/lib/form-fill-dialog-context";
import { useSubmissionOpenable } from "#app/lib/forms";
import { useViewerIsShareOnly } from "#app/lib/hooks/use-permission";
import type { ActivityChange } from "../activity-types";

export function FormSubmissionChunk({ change }: { change: ActivityChange }) {
  const { open } = useFormFillDialogActions();
  const { submissionId, issueId } = (change.newValue ?? {}) as { submissionId?: string; issueId?: string };
  const formsOn = useFeatureFlags().hasFlag(FeatureFlagKey.FORMS);
  const openable = useSubmissionOpenable(formsOn ? issueId : undefined, submissionId);
  const shareOnly = useViewerIsShareOnly();
  const canOpen = formsOn && openable && !shareOnly;
  return (
    <Text size="sm">
      submitted{" "}
      {canOpen && submissionId && issueId ? (
        <Text
          size="sm"
          weight="medium"
          hoverInk
          className="cursor-pointer"
          onClick={() => open({ issueId, kind: "submission", submissionId })}
        >
          {change.target.label}
        </Text>
      ) : (
        <Text size="sm" weight="medium">
          {change.target.label}
        </Text>
      )}
    </Text>
  );
}
